import React from 'react';
import { EmojiPrefix } from '../../view';

export const SingleValue = (props: any) => {
    const { children, className, cx, data, isDisabled, innerProps } = props;

    return (
        <div
            className={cx(
                {
                    'single-value': true,
                    'single-value--is-disabled': isDisabled,
                },
                className,
            )}
            {...innerProps}
        >
            {data.emojiString && <EmojiPrefix>{data.emojiString}</EmojiPrefix>}
            {children}
        </div>
    );
};
